import { Translatable } from "@icc/shared/helpers";

export class RollerAdapter {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Masa za metr bieżący [kg] */
    weight?: number;
    /** Maksymalna długość rolety [mm] */
    maxLength?: number;
    /** Powiązane profile */
    profilesIds?: number[];
    /** Czy wybrane automatycznie */
    isDefault?: boolean;
    /** Typ adaptera okiennego */
    rollerBoxAdapterType?: 'adapter' | 'traverse' | null;
    /** Identyfikator zestawu grup kolorów */
    colorGroupSetId?: number | null;
    /** ID profilu stalowego wzmocnienia trawersy (np. RST-010), null gdy brak */
    steelReinforcementId?: number | null;
}